<template>
  <div
    class="rightSideColumn"
    :class="{
      rightSideColumnExpanded: $store.state.display.rightSideColumn.isExpanded
    }"
  >
    <GroupInfoColumn
      v-if="$store.state.display.rightSideColumn.visibleContent === 'group'"
    />
    <ContactInfoColumn
      v-if="$store.state.display.rightSideColumn.visibleContent === 'contact'"
    />
    <ChannelInfoColumn
      v-if="$store.state.display.rightSideColumn.visibleContent === 'channel'"
    />
  </div>
</template>

<script>
import ContactInfoColumn from './rightSideColumns/ContactInfoColumn.vue'
import ChannelInfoColumn from './rightSideColumns/ChannelInfoColumn.vue'
import GroupInfoColumn from './rightSideColumns/GroupInfoColumn.vue'
export default {
  components: {
    GroupInfoColumn,
    ContactInfoColumn,
    ChannelInfoColumn
  }
}
</script>

<style scoped>
.rightSideColumnExpanded {
  width: 300px !important;
}

.rightSideColumn {
  width: 0px;
  flex-shrink: 0;
  transition: width 0.2s ease;
  overflow: hidden;
  height: 100%;
}
</style>
